<template>
  <div>
    <div class="box-div" :class="showType === 'login' ? 'cur' : ''" :style="{display: findPassword ? 'none' : 'block'}">
      <div class="login-title">{{siteTitle}}</div>
      <!-- 账号登录 -->
      <el-form ref="formLogin" style="margin-top: 20px;" :model="loginJson" :rules="loginCheck" @keyup.enter.native="login('formLogin')">
        <el-form-item label="" prop="userName">
          <el-input v-model="loginJson.userName" autofocus placeholder="手机号/邮箱"></el-input>
        </el-form-item>
        <el-form-item label="" prop="passWord">
          <el-input v-model="loginJson.passWord" autofocus placeholder="密码" show-password></el-input>
        </el-form-item>
        <div style="margin-top: 10px; text-align: right;"><span class="blueText" @click="forgetPassword(true)">忘记密码</span></div>
        <el-form-item>
          <el-button type="primary" @click="login('formLogin')" style="width: 400px; margin-top: 20px;" :loading="loading">
            <span v-if="!loading">登录</span>
            <span v-else>请稍后...</span>
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div v-if="findPassword" :style="{display: findPassword ? 'block' : 'none'}"><VerifyForm :siteTitle.sync="siteTitle" :showType.sync="showType" :qrcode.sync="qrcode" :loginInfo.sync="loginInfo" @backLogin="backLogin" /></div>
  </div>
</template>

<script>
import VerifyForm from './verifyForm.vue';

export default {
  name: "login",
  components: {
    VerifyForm
  },
  props: {
    siteTitle: String,
    showType: String,
  },
  data() {
    return {
      loading: false,
      // 登录
      loginJson: {
        userName: "",
        passWord: "",
      },
      loginCheck: {
        userName: [{ required: true, message: "请输入用户名", trigger: "change" }],
        passWord: [{ required: true, message: "请输入密码", trigger: "change" }],
      },

      // 找回密码
      findPassword: false,

      // 扫码登录注册
      qrcode: null,
      loginInfo: null,
    };
  },
  mounted() {
    
  },
  methods: {
    // 登陆
    login(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("user/login", this.loginJson)
            .then(res => {
              if(res.success) {
								// this.$Message.success("正常登录成功");
								// this.$router.push({
								// 	name: this.$indexPage,
								// });
                this.$emit('loginSuccess')
							} else {
								this.$message({
                  message: res.msg,
                  type: 'error'
                })
							}
							this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },

    // 忘记密码
    forgetPassword() {
      this.findPassword = true;
      this.$emit('verifyCode')
    },

    // 返回登录
    backLogin() {
      this.findPassword = false;
      this.$emit('backIndex')
      // this.$parent.backIndex();
    },
  },
  watch: {},
  filters: {},
};
</script>

<style lang="less">
.login-title {
  font-size: 26px;
  padding: 50px 0 20px;
  text-align: center;
}

.box-div {
  opacity: 0;
  transition: .5s;

  &.cur {
    opacity: 1;
  }
}
</style>